import { Avatar, Box, Drawer, CircularProgress } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { getInternStudent, getInternshipRequest, getInternshipRequest3, getInternStudent3, getSchoolYear } from "../api/crud";
import ModalCrudCompany2 from "../Components/company-form/ModalCrudCompany2";
import InternData from "../Components/InternData";
import ProfileDetail from "../Components/ProfileDetail";
import { optionsBranch } from "../data/branch-data";
import SummaryCardEl from "../Elements/SummaryCardEl";
import { convertDateToString, convertTime, timeSince } from "../utils/function";
import { generateStatus } from "../utils/generateDisplay";
import { BiDotsVerticalRounded } from "react-icons/bi";
import ModalView from "../Components/ModalView";
import dayjs from "dayjs";

// Helper function สำหรับเปรียบเทียบ status_id
const isStatusEqual = (statusId, targetStatus) => Number(statusId) === Number(targetStatus);
const isStatusNotEqual = (statusId, targetStatus) => Number(statusId) !== Number(targetStatus);

const Dashboard = () => {
  const navigate = useNavigate();
  const optionsNewBranch = [
    {
      label: "ทั้งหมด",
      value: 0,
    },
    ...optionsBranch,
  ];
  const getStatus = window.localStorage.getItem("status");
  const profile = useSelector((state) => state.profileReducer.profile);
  const [internStudentList, setInternStudentList] = useState([]);
  const [internStudentList2, setInternStudentList2] = useState([]);
  const [internStudentList3, setInternStudentList3] = useState([]);
  const [internStudentActive, setinternStudentActive] = useState([]);
  const [internType1, setinternType1] = useState([]);
  const [internType2, setinternType2] = useState([]);
  const [internType3, setinternType3] = useState([]);

  const [internType1a, setinternType1a] = useState([]);
  const [internType2a, setinternType2a] = useState([]);
  const [internType3a, setinternType3a] = useState([]);

  const [internFilterTypeList, setInternFilterTypeList] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [displayedList, setDisplayedList] = useState([]);
  const [itemsPerBatch] = useState(15); // ลดจาก 20 เป็น 15 เพื่อลดการโหลดรูป
  const [currentBatch, setCurrentBatch] = useState(1);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [loadedImages, setLoadedImages] = useState(new Set()); // Track loaded images
  const [showBackToTop, setShowBackToTop] = useState(false); // Show back to top button
  const [searchTerm, setSearchTerm] = useState("");
  const [studentSelected, setStudentSelected] = useState(null);

  // Optimized callback สำหรับ Avatar onClick
  const handleAvatarClick = useCallback((student) => {
    setStudentSelected(student);
  }, []);

  // Optimized callback สำหรับ Row onClick  
  const handleRowClick = useCallback((student) => {
    setStudentSelected(student);
  }, []);
  
  // โหลดค่าจาก localStorage ก่อน
  const [branchSelected, setBranchSelected] = useState(() => {
    const savedBranch = localStorage.getItem('dashboardBranchSelected');
    return savedBranch ? JSON.parse(savedBranch) : optionsNewBranch[0];
  });
  
  const [statusFocused, setStatusFocused] = useState(0);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenModal2, setIsOpenModal2] = useState(false);
  const [modalChartOpen, setModalChartOpen] = useState(false);
  const [modalChartOpen2, setModalChartOpen2] = useState(false);
  const [schoolYear, setSchoolYear] = useState([]);
  
  // โหลดปีการศึกษาจาก localStorage ก่อน
  const [selectedYear, setSelectedYear] = useState(() => {
    const savedYear = localStorage.getItem('dashboardSelectedYear');
    return savedYear ? JSON.parse(savedYear) : null;
  });

  useEffect(() => {
    if (getStatus === "student") {
      navigate("/");
    }
  }, [getStatus, navigate]);

  const matchOptions = (options, value = "") => {
    const match = options.find((item) => item.value == value);

    return match ? match.label : "-";
  };

  const onHandleBranchSelect = (data) => {
    setBranchSelected(data);
    // บันทึกลง localStorage
    localStorage.setItem('dashboardBranchSelected', JSON.stringify(data));
  };

  const onSearchChange = (ev) => {
    setSearchTerm(ev.target.value);

    const results = internFilterTypeList.filter((item) => {
      return (
        item.id.toLowerCase().includes(ev.target.value.toLowerCase()) ||
        item.name.toLowerCase().includes(ev.target.value.toLowerCase()) ||
        item.status_byuser
          .toLowerCase()
          .includes(ev.target.value.toLowerCase()) ||
        item.branch_name?.toLowerCase().includes(ev.target.value.toLowerCase())
      );
    });

    setFilterList(results);
    // Reset pagination when search changes
    setCurrentBatch(1);
    setDisplayedList(results.slice(0, itemsPerBatch));
  };

  // Lazy loading functions
  const initializeDisplayedList = useCallback((list) => {
    setCurrentBatch(1);
    setDisplayedList(list.slice(0, itemsPerBatch));
  }, [itemsPerBatch]);

  const loadMoreItems = () => {
    if (isLoadingMore) return;
    
    setIsLoadingMore(true);
    setTimeout(() => {
      const nextBatch = currentBatch + 1;
      const startIndex = currentBatch * itemsPerBatch;
      const endIndex = nextBatch * itemsPerBatch;
      const moreItems = filterList.slice(startIndex, endIndex);
      
      setDisplayedList(prev => [...prev, ...moreItems]);
      setCurrentBatch(nextBatch);
      setIsLoadingMore(false);
    }, 500); // เพิ่ม delay เป็น 500ms เพื่อให้รูปโหลดทีละน้อย
  };

  const handleScroll = (e) => {
    const element = e.target;
    const threshold = 200; // Load more when 200px from bottom
    const showButtonThreshold = 150; // ลดจาก 300 เป็น 150px เพื่อให้แสดงเร็วขึ้น
    
    // Show/hide back to top button with debounce
    const isScrolledDown = element.scrollTop > showButtonThreshold;
    
    if (isScrolledDown !== showBackToTop) {
      setShowBackToTop(isScrolledDown);
    }
    
    // Load more items
    if (element.scrollHeight - element.scrollTop - element.clientHeight < threshold) {
      if (displayedList.length < filterList.length && !isLoadingMore) {
        loadMoreItems();
      }
    }
  };

  // Function to scroll back to top
  const scrollToTop = () => {
    const tableContainer = document.querySelector('.table-scroll-container');
    if (tableContainer) {
      tableContainer.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  const handleYearChange = (data) => {
    const schoolYear = {
      school_yrs: data.value,
    };

    setSelectedYear(schoolYear.school_yrs);
    // บันทึกลง localStorage
    localStorage.setItem('dashboardSelectedYear', JSON.stringify(schoolYear.school_yrs));
 

    
  };

  const schoolYearsOptions = [
    {value: schoolYear.school_yrs, label: schoolYear.school_yrs},
    {value: schoolYear.school_yrs - 1, label: schoolYear.school_yrs - 1},
    {value: schoolYear.school_yrs - 2, label: schoolYear.school_yrs - 2},
    {value: schoolYear.school_yrs - 3, label: schoolYear.school_yrs - 3},
  
  ]

  const getInternStudentList = useCallback(async () => {
    const schoolYear = await getSchoolYear();
      setSchoolYear(schoolYear);
      let internshipRequest ;
       console.log(selectedYear);
      if(selectedYear){ internshipRequest = await getInternshipRequest3(selectedYear);
        console.log(internshipRequest);
      }else{
        internshipRequest = await getInternshipRequest();
          setSelectedYear(schoolYear.school_yrs);
      }

    const activeInternshipRequest = internshipRequest.filter(
      (res) => res.status !== "0" && res.req_id
    );

    if (selectedYear) {
      await getInternStudent3(selectedYear)
        .then((res) => {
          const list = res.map((el) => {
            const matchIntern = activeInternshipRequest?.find(
              (item) => item.st_id === el.id
            );
    
            return {
              ...el,
              branch_name: matchOptions(optionsBranch, el.b_id),
              internshipRequest: matchIntern,
            };
          });
    
          // ตรวจสอบค่า list หลังการ map
          console.log("List after map:", list);
    
          const studentByBranch = list?.filter((student) => {
            if (branchSelected?.value == 0) {
              return student;
            } else {
              return student.b_id == branchSelected?.value;
            }
          });
    
          // ตรวจสอบค่า studentByBranch หลังจากการกรองครั้งแรก
          console.log("Student by Branch:", studentByBranch);
    
          const internStdActive = list.filter((st) => st.internshipRequest);
    
          // ตรวจสอบค่า internStdActive หลังจากการกรอง
          console.log("Intern students with active requests:", internStdActive);
    
          const filterType1 = studentByBranch.filter(
            (item) => item?.internshipRequest?.type_internship == "1"
          );
          const filterType2 = studentByBranch.filter(
            (item) => item?.internshipRequest?.type_internship == "2"
          );
          const filterType3 = studentByBranch.filter(
            (item) => item?.internshipRequest?.type_internship == "3"
          );
    
          // ตรวจสอบค่าหลังการกรองตามประเภทของการฝึกงาน
          console.log("Filter Type 1:", filterType1);
          console.log("Filter Type 2:", filterType2);
          console.log("Filter Type 3:", filterType3);
    
          const filterType1a = internStdActive.filter(
            (item) => item?.internshipRequest?.type_internship == "1"
          );
          const filterType2a = internStdActive.filter(
            (item) => item?.internshipRequest?.type_internship == "2"
          );
          const filterType3a = internStdActive.filter(
            (item) => item?.internshipRequest?.type_internship == "3"
          );
    
          // ตรวจสอบค่า filterType1a, filterType2a, filterType3a
          console.log("Filter Type 1a:", filterType1a);
          console.log("Filter Type 2a:", filterType2a);
          console.log("Filter Type 3a:", filterType3a);
    
          // อัปเดตค่า state ต่างๆ
          setinternType1a(filterType1a);
          setinternType2a(filterType2a);
          setinternType3a(filterType3a);
    
          setinternStudentActive(studentByBranch);
    
          setinternType1(filterType1);
          setinternType2(filterType2);
          setinternType3(filterType3);
    
          setInternStudentList(studentByBranch);
          setInternStudentList2(list);
          setInternStudentList3(internStdActive);
          setInternFilterTypeList(studentByBranch);
          setFilterList(studentByBranch);
          // Initialize displayed list for lazy loading
          initializeDisplayedList(studentByBranch);
    
        })
        .catch((err) => {
          console.log(err);
        });
    }
    
    else{
      await getInternStudent()
      .then((res) => {
        const list = res.map((el) => {
          const matchIntern = activeInternshipRequest.find(
            (item) => item.st_id === el.id
          );

          return {
            ...el,
            branch_name: matchOptions(optionsBranch, el.b_id),
            internshipRequest: matchIntern,
          };
        });

        const studentByBranch = list.filter((student) => {
          if (branchSelected?.value == 0) {
            return student;
          } else {
            return student.b_id == branchSelected?.value;
          }
        });

        const internStdActive = list.filter((st) => st.internshipRequest);

        const filterType1 = studentByBranch.filter(
          (item) => item?.internshipRequest?.type_internship == "1"
        );
        const filterType2 = studentByBranch.filter(
          (item) => item?.internshipRequest?.type_internship == "2"
        );
        const filterType3 = studentByBranch.filter(
          (item) => item?.internshipRequest?.type_internship == "3"
        );

        const filterType1a = internStdActive.filter(
          (item) => item?.internshipRequest?.type_internship == "1"
        );
        const filterType2a = internStdActive.filter(
          (item) => item?.internshipRequest?.type_internship == "2"
        );
        const filterType3a = internStdActive.filter(
          (item) => item?.internshipRequest?.type_internship == "3"
        );

        setinternType1a(filterType1a);
        setinternType2a(filterType2a);
        setinternType3a(filterType3a);

        setinternStudentActive(studentByBranch);

        setinternType1(filterType1);
        setinternType2(filterType2);
        setinternType3(filterType3);

        setInternStudentList(studentByBranch);
        setInternStudentList2(list);
        setInternStudentList3(internStdActive);
        setInternFilterTypeList(studentByBranch);
        setFilterList(studentByBranch);
        // Initialize displayed list for lazy loading
        initializeDisplayedList(studentByBranch);
        console.log("setFilterList",studentByBranch);


      })
      .catch((err) => {
        console.log(err);
      });
      setSelectedYear(schoolYear.school_yrs);

    }
  }, [selectedYear, branchSelected?.value, initializeDisplayedList]);

  useEffect(() => {
    if (profile && profile.b_id) {
      // ตรวจสอบว่ามีข้อมูลใน localStorage หรือไม่
      const savedBranch = localStorage.getItem('dashboardBranchSelected');
      
      if (!savedBranch) {
        // ถ้าไม่มีข้อมูลใน localStorage ให้ใช้ค่าจาก profile
        const matchBranch = optionsBranch.find(
          (opt) => opt.value == profile.b_id
        );
        const branchToSet = matchBranch || { value: 0, label: "ทั้งหมด" };
        setBranchSelected(branchToSet);
        localStorage.setItem('dashboardBranchSelected', JSON.stringify(branchToSet));
      }
      // ถ้ามีข้อมูลใน localStorage แล้ว ไม่ต้องทำอะไร (ใช้ค่าจาก localStorage)
    }
  }, [profile]);

  useEffect(() => {
    console.log("Branch Selected:", branchSelected);
    if (branchSelected) {  // เพิ่มเงื่อนไขการตรวจสอบ
      getInternStudentList();
    }
  }, [branchSelected, selectedYear, getInternStudentList]);

  // useEffect สำหรับตั้งค่าปีการศึกษาเริ่มต้นจาก localStorage หรือ schoolYear
  useEffect(() => {
    if (schoolYear.school_yrs && !selectedYear) {
      const savedYear = localStorage.getItem('dashboardSelectedYear');
      if (savedYear) {
        const parsedYear = JSON.parse(savedYear);
        // ตรวจสอบว่าปีที่บันทึกไว้ยังอยู่ในช่วงที่ใช้งานได้หรือไม่
        if (parsedYear >= schoolYear.school_yrs - 3 && parsedYear <= schoolYear.school_yrs) {
          setSelectedYear(parsedYear);
        } else {
          // ถ้าปีที่บันทึกไว้ไม่อยู่ในช่วงที่ใช้งานได้ ให้ใช้ปีปัจจุบัน
          setSelectedYear(schoolYear.school_yrs);
          localStorage.setItem('dashboardSelectedYear', JSON.stringify(schoolYear.school_yrs));
        }
      } else {
        // ถ้าไม่มีข้อมูลใน localStorage ให้ใช้ปีปัจจุบัน
        setSelectedYear(schoolYear.school_yrs);
        localStorage.setItem('dashboardSelectedYear', JSON.stringify(schoolYear.school_yrs));
      }
    }
  }, [schoolYear, selectedYear]);

  // useEffect สำหรับจัดการ lazy loading เมื่อ filterList เปลี่ยน
  useEffect(() => {
    if (filterList.length > 0) {
      initializeDisplayedList(filterList);
    } else {
      setDisplayedList([]);
    }
  }, [filterList, initializeDisplayedList]);

  // Component สำหรับ Avatar ที่มี lazy loading - ใช้ React.memo เพื่อป้องกัน unnecessary re-renders
  const LazyAvatar = React.memo(({ studentId, studentName, onClick }) => {
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageError, setImageError] = useState(false);
    
    const handleImageLoad = () => {
      setImageLoaded(true);
      setLoadedImages(prev => new Set([...prev, studentId]));
    };
    
    const handleImageError = () => {
      setImageError(true);
    };

    const handleClick = (e) => {
      if (onClick) {
        // ไม่ใช้ stopPropagation เพื่อให้ row onClick ยังทำงานได้
        onClick(e);
      }
    };

    if (imageError) {
      return (
        <Avatar
          sx={{ 
            width: 25, 
            height: 25, 
            backgroundColor: '#e3f2fd', 
            color: '#1976d2',
            cursor: 'pointer',
            pointerEvents: 'auto',
            zIndex: 999,
            position: 'relative',
            '&:hover': {
              backgroundColor: '#bbdefb',
              transform: 'scale(1.1)'
            }
          }}
          onClick={handleClick}
          onMouseDown={(e) => e.stopPropagation()}
          onMouseUp={handleClick}
        >
          {studentName?.charAt(0) || '?'}
        </Avatar>
      );
    }

    return (
      <Avatar
        alt="profile"
        sx={{ 
          width: 25, 
          height: 25,
          backgroundColor: imageLoaded ? 'transparent' : '#f5f5f5',
          cursor: 'pointer',
          pointerEvents: 'auto',
          zIndex: 999,
          position: 'relative',
          '&:hover': {
            transform: 'scale(1.1)',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
          }
        }}
        src={`https://reg.buu.ac.th/registrar/getstudentimage.asp?id=${studentId}`}
        onLoad={handleImageLoad}
        onError={handleImageError}
        onClick={handleClick}
        onMouseDown={(e) => e.stopPropagation()}
        onMouseUp={handleClick}
      >
        {!imageLoaded && (studentName?.charAt(0) || '?')}
      </Avatar>
    );
  });

 

  

  const ProgressBarEl = ({ stList = [], bgColor, statusId, statusIdPrev }) => {
    return (
      <div
        className="progress-bar"
        role="progressbar"
        aria-label="Segment two"
        style={{
          width: `${
            (stList.filter((el) => el.status_id == statusId).length /
              stList.length) *
            100
          }%`,
          backgroundColor: bgColor,
        }}
        aria-valuenow={stList.filter((el) => el.status_id == statusId).length}
        aria-valuemin={
          statusIdPrev
            ? stList.filter((el) => el.status_id == statusIdPrev).length
            : 0
        }
        aria-valuemax={stList.length}
      />
    );
  };

  const displayTable = (
    <>
      <style>
        {`
          .back-to-top-btn {
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .back-to-top-btn.visible {
            opacity: 1 !important;
            visibility: visible !important;
            transform: scale(1) translateY(0) !important;
          }
          .back-to-top-btn.invisible {
            opacity: 0 !important;
            visibility: hidden !important;
            transform: scale(0.8) translateY(10px) !important;
          }
        `}
      </style>
      <div className="card-header bg-light border-bottom">
        <div className="row align-items-center">
          <div className="col-md-8">
            <h4 className="card-title mb-0 text-primary fw-bold" style={{ fontSize: '1.5rem' }}>
              
              รายชื่อนิสิต {branchSelected?.label} {generateStatus(statusFocused)}
            </h4>
          </div>
          <div className="col-md-4">
            <div className="input-group">
              <span className="input-group-text bg-white border-end-0">
                <i className="fas fa-search text-muted"></i>
              </span>
              <input
                type="text"
                className="form-control border-start-0 border-end-0 ps-0"
                placeholder="ค้นหารหัส, ชื่อ, สาขา..."
                onChange={onSearchChange}
                value={searchTerm}
              />
              {searchTerm && (
                <span 
                  className="input-group-text bg-white border-start-0 cursor-pointer"
                  onClick={() => onSearchChange({ target: { value: '' } })}
                  style={{ cursor: 'pointer' }}
                >
                  <i className="fas fa-times text-muted"></i>
                </span>
              )}
            </div>
            {!!searchTerm && (
              <small className="text-muted mt-1 d-block">
                <i className="fas fa-info-circle me-1"></i>
                พบ {filterList.length} ผลลัพธ์ {displayedList.length < filterList.length && `(แสดง ${displayedList.length} รายการ)`}
                <br />
                <i className="fas fa-image me-1"></i>
                รูปภาพโหลดแล้ว: {loadedImages.size} รูป
              </small>
            )}
          </div>
        </div>
      </div>

      <div 
        className="overflow-auto table-scroll-container" 
        style={{ maxHeight: '600px', position: 'relative' }} 
        onScroll={handleScroll}
      >
        <table
          id="datatables-dashboard-projects"
          className="table table-striped my-0 table-hover"
        >
          <thead className="table-info">
            <tr className="text-nowrap">
              <th className="text-center">ลำดับ</th>
              <th>รหัสนิสิต</th>
              <th>ชื่อ - สกุล</th>
              <th>สาขา</th>
              <th>สถานะ</th>
              <th>อัพเดทเมื่อ</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {displayedList.length > 0 ? (
              displayedList.map((item, index) => {
                return (
                  <tr
                    className="text-nowrap"
                    key={item.id}
                    onClick={() => handleRowClick(item)}
                    role="button"
                  >
                    <td className="text-center">{index + 1}</td>
                    <td>{item.id}</td>
                    <td>
                      <span className="d-flex">
                        <LazyAvatar 
                          studentId={item.id}
                          studentName={item.name}
                          onClick={() => handleAvatarClick(item)}
                        />
                        <span className="ms-2">{item.name}</span>
                      </span>
                    </td>
                    <td>
                      {/* {matchOptions(optionsBranch, item.b_id)} */}
                      {item.branch_name}
                    </td>

                    <td>{generateStatus(item.status_id)}</td>
                    <td>
                      <span>
                        {convertDateToString(item.timeStamp)}{" "}
                        {convertTime(item.timeStamp)}{" "}
                      </span>
                      <div>
                        <small>
                          {item.status_byuser && isNaN(item.status_byuser)
                            ? `โดย ${item.status_byuser}`
                            : ""}
                        </small>
                      </div>
                    </td>
                    <td>
                      <span
                        className="badge"
                        style={{ background: "#FEFAC2", color: "gray" }}
                      >
                        {timeSince(item.timeStamp)}
                      </span>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-5">
                  <div className="text-muted">
                    <i className="fas fa-search fa-2x mb-3"></i>
                    <br />
                    <h5>ไม่พบข้อมูลที่ค้นหา</h5>
                    <p>ลองเปลี่ยนคำค้นหาหรือเลือกสถานะอื่น</p>
                  </div>
                </td>
              </tr>
            )}
            {/* Loading indicator */}
            {isLoadingMore && (
              <tr>
                <td colSpan="7" className="text-center py-3">
                  <div className="d-flex justify-content-center align-items-center">
                    <CircularProgress size={20} className="me-2" />
                    <span className="text-muted">กำลังโหลดข้อมูลเพิ่มเติม...</span>
                  </div>
                </td>
              </tr>
            )}
            {/* Show more info */}
            {!isLoadingMore && displayedList.length < filterList.length && (
              <tr>
                <td colSpan="7" className="text-center py-2">
                  <small className="text-muted">
                    แสดง {displayedList.length} จาก {filterList.length} รายการ - เลื่อนลงเพื่อโหลดเพิ่มเติม
                  </small>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        
        {/* Back to Top Button */}
        <button
          className={`btn rounded-circle position-fixed back-to-top-btn ${showBackToTop ? 'visible' : 'invisible'}`}
          onClick={scrollToTop}
          style={{
            bottom: '25px',
            right: '25px',
            width: '45px',
            height: '45px',
            zIndex: 9999,
            boxShadow: '0 4px 15px rgba(108, 117, 125, 0.3)',
            border: '1px solid rgba(255,255,255,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '16px',
            fontWeight: 'normal',
            background: 'rgba(248, 249, 250, 0.95)',
            color: '#6c757d',
            cursor: 'pointer',
            backdropFilter: 'blur(10px)'
          }}
          title="กลับไปด้านบน"
          onMouseEnter={(e) => {
            if (showBackToTop) {
              e.target.style.transform = 'scale(1.05) translateY(-1px)';
              e.target.style.background = 'rgba(233, 236, 239, 0.98)';
              e.target.style.color = '#495057';
              e.target.style.boxShadow = '0 6px 20px rgba(108, 117, 125, 0.4)';
            }
          }}
          onMouseLeave={(e) => {
            if (showBackToTop) {
              e.target.style.transform = 'scale(1) translateY(0)';
              e.target.style.background = 'rgba(248, 249, 250, 0.95)';
              e.target.style.color = '#6c757d';
              e.target.style.boxShadow = '0 4px 15px rgba(108, 117, 125, 0.3)';
            }
          }}
        >
          <i className="fas fa-chevron-up"></i>
        </button>
      </div>
    </>
  );

  const displayProfile = (
    <Drawer
      anchor="right"
      open={Boolean(studentSelected)}
      onClose={() => {
        setStudentSelected(null);
      }}
    >
      <div
        className="card-body shadow-lg"
        style={{ width: "80vw", maxWidth: "600px" }}
      >
        <div className="row g-0">
          {(studentSelected?.status_id == "0" ||
            studentSelected?.status_id == "32" ||
            studentSelected?.status_id == "14" ||
            studentSelected?.status_id == "15") && (
            <div className="col-12 text-end p-2">
              <span className="dropdown">
                <BiDotsVerticalRounded
                  size="1.5rem"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                />
                <ul className="dropdown-menu">
                  <li>
                    <form action="./cancel-register.php" method="post">
                      <input
                        className="d-none"
                        defaultValue={studentSelected?.id}
                        name="st_id"
                      />
                      <input
                        className="d-none"
                        defaultValue={profile?.id}
                        name="user"
                      />
                      <button
                        className="btn btn-light dropdown-item"
                        type="submit"
                      >
                        ยกเลิก
                      </button>
                    </form>
                  </li>
                </ul>
              </span>
            </div>
          )}
          <div className="col-12 mb-4">
            <ProfileDetail st_id={studentSelected?.id} />
          </div>
          <div className="col-12 mb-4">
            <InternData st_id={studentSelected?.id} />
          </div>
        </div>

        <hr />
        {/* <ActivityLog /> */}
      </div>
    </Drawer>
  );

  const displayDashboard = (
    <div className="main">
      <main className="content">
        <div className="container-fluid p-0">
          <div className="card bg-gradient-light border-0 shadow-sm mb-4">
            <div className="card-body py-3">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="d-flex align-items-center">
                    <h2 className="mb-0 fw-bold text-dark me-4">
                      สรุปการยื่นขอฝึกงานและสหกิจศึกษา
                    </h2>
                    <div className="d-flex align-items-center">
                      <span className="text-muted me-2">ปีการศึกษา:</span>
                      <div style={{ minWidth: "120px" }}>
                        <Select
                          options={schoolYearsOptions}
                          value={schoolYearsOptions.find((item) => item.value == selectedYear)}
                          onChange={handleYearChange}
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              minHeight: '32px',
                              fontSize: '14px',
                              border: '1px solid #ced4da',
                              borderRadius: '6px'
                            })
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="d-flex align-items-center justify-content-md-end">
                    <span className="text-muted me-2">สาขา:</span>
                    <div style={{ minWidth: "300px" }}>
                      <Select
                        options={optionsNewBranch}
                        value={branchSelected}
                        onChange={onHandleBranchSelect}
                        isDisabled={profile && profile.b_id == 0 ? false : true}
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            minHeight: '38px',
                            fontSize: '14px',
                            border: '1px solid #ced4da',
                            borderRadius: '6px',
                            boxShadow: 'none',
                            '&:hover': {
                              borderColor: '#80bdff'
                            }
                          }),
                          menu: (provided) => ({
                            ...provided,
                            minWidth: '300px',
                            zIndex: 9999
                          })
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style={{ gap: "2px 0" }}>
            <div className="col-md-4" style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
              <div
                className="card shadow border-success"
                role="button"
                onClick={() => setModalChartOpen(true)}
              >
                <div className="card-body p-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>สถานะการยื่นขอการฝึกงานของนิสิต</div>
                    <div>
                      {internStudentList.filter((el) => Number(el.status_id) !== 0)
                        .length -
                        internStudentList.filter((el) => el.status_id == 32)
                          .length -
                        internStudentList.filter((el) => el.status_id == 15)
                          .length -
                        internStudentList.filter((el) => el.status_id == 14)
                          .length}{" "}
                      / {internStudentList.length}
                    </div>
                  </div>
                  <div className="progress">
                    <ProgressBarEl
                      stList={internStudentList}
                      bgColor="#F7F759"
                      statusId={11}
                    />
                    <ProgressBarEl
                      stList={internStudentList}
                      bgColor="blue"
                      statusId={1}
                      statusIdPrev={11}
                    />
                    <ProgressBarEl
                      stList={internStudentList}
                      bgColor="green"
                      statusId={12}
                      statusIdPrev={1}
                    />
                    <ProgressBarEl
                      stList={internStudentList}
                      bgColor="orange"
                      statusId={2}
                      statusIdPrev={12}
                    />
                    <ProgressBarEl
                      stList={internStudentList}
                      bgColor="#F1D507"
                      statusId={21}
                      statusIdPrev={2}
                    />
                    <ProgressBarEl
                      stList={internStudentList}
                      bgColor="#1876D1"
                      statusId={3}
                      statusIdPrev={21}
                    />
                    <ProgressBarEl
                      stList={internStudentList}
                      bgColor="#00FF15"
                      statusId={31}
                      statusIdPrev={3}
                    />
                  </div>
                </div>
              </div>

              <div
                className="card shadow border-success"
                role="button"
                onClick={() => setModalChartOpen2(true)}
              >
                <div className="card-body p-3">
                  <div className="d-flex justify-content-between align-items-center">
                    {internType1.length > 0 && (
                      <div>ฝึกงาน 2 เดือน</div>
                    )}
                    {([...internType2, ...internType3].length > 0 && (
                      <div>สหกิจศึกษา</div>
                    ))}
                  </div>

                  <div className="progress">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      aria-label="type-1"
                      style={{
                        width: `${Math.round(
                          (internType1.length /
                            (internStudentActive.filter(
                              (el) => Number(el.status_id) !== 0
                            ).length -
                              internStudentActive.filter(
                                (el) => el.status_id == 15
                              ).length -
                              internStudentActive.filter(
                                (el) => el.status_id == 32
                              ).length -
                              internStudentActive.filter(
                                (el) => el.status_id == 14
                              ).length-
                              internStudentActive.filter(
                                (el) => el.status_id == 13
                              ).length
                            
                            )) *
                            100
                        )}%`,
                      }}

                      aria-valuenow={Math.round(
                        (internType1.length /
                          (internStudentActive.filter((el) => Number(el.status_id) !== 0)
                            .length -
                            internStudentActive.filter(
                              (el) => el.status_id == 15
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 32
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 14
                            ).length-
                            internStudentActive.filter(
                              (el) => el.status_id == 13
                            ).length
                          
                          )) *
                          100
                      )}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >

                      {`${Math.round(
                        (internType1.length /
                          (internStudentActive.filter((el) => Number(el.status_id) !== 0)
                            .length -
                            internStudentActive.filter(
                              (el) => el.status_id == 15
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 32
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 13
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 14
                            ).length)) *
                          100
                      )}%`}
                    </div>

                    <div
                      className="progress-bar bg-success"
                      role="progressbar"
                      aria-label="type-2-3"
                      style={{
                        width: `${Math.round(
                          ([...internType2, ...internType3].length /
                            (internStudentActive.filter(
                              (el) => Number(el.status_id) !== 0
                            ).length -
                              internStudentActive.filter(
                                (el) => el.status_id == 15
                              ).length -
                              internStudentActive.filter(
                                (el) => el.status_id == 32
                              ).length -
                              internStudentActive.filter(
                                (el) => el.status_id == 14
                              ).length -
                              internStudentActive.filter(
                                (el) => el.status_id == 13
                              ).length
                            
                            )) *
                            100
                        )}%`,
                      }}
                      aria-valuenow={Math.round(
                        (internType1.length /
                          (internStudentActive.filter((el) => Number(el.status_id) !== 0)
                            .length -
                            internStudentActive.filter(
                              (el) => el.status_id == 15
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 32
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 14
                            ).length-
                            internStudentActive.filter(
                              (el) => el.status_id == 13
                            ).length

                          )) *
                          100
                      )}
                      aria-valuemin={Math.round(
                        ([...internType2, ...internType3].length /
                          (internStudentActive.filter((el) => Number(el.status_id) !== 0)
                            .length -
                            internStudentActive.filter(
                              (el) => el.status_id == 15
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 32
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 14
                            ).length-
                            internStudentActive.filter(
                              (el) => el.status_id == 13
                            ).length
                          )) *
                          100
                      )}
                      aria-valuemax={100}
                    >
                      {`${Math.round(
                        ([...internType2, ...internType3].length /
                          (internStudentActive.filter((el) => Number(el.status_id) !== 0)
                            .length -
                            internStudentActive.filter(
                              (el) => el.status_id == 15
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 32
                            ).length -
                            internStudentActive.filter(
                              (el) => el.status_id == 14
                            ).length-
                            internStudentActive.filter(
                              (el) => el.status_id == 13
                            ).length
                          )) *
                          100
                      )}%`}
                    </div>
                  </div>
                </div>
              </div>
            </div>

           
             
             
              
            <div className="col-md-8">
              <div style={{ display: "flex", gap: "2px" }}>
                <div style={{ flex: 1 }}>
                  <SummaryCardEl
                    setStatusFocused={setStatusFocused}
                    statusFocused={statusFocused}
                    setFilterList={setFilterList}
                    setInternFilterTypeList={setInternFilterTypeList}
                    status_id={0}
                    data={internStudentList}
                    title="ลงทะเบียนขอฝึกงานและสหกิจศึกษา"
                    qtyColorText=""
                    cardWidth="100%"
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <SummaryCardEl
                    cardWidth="100%"
                    setStatusFocused={setStatusFocused}
                    statusFocused={statusFocused}
                    setFilterList={setFilterList}
                    setInternFilterTypeList={setInternFilterTypeList}
                    status_id={101}
                    data={internType1}
                    title="ฝึกงาน 2 เดือน"
                    qtyColorText=""
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <SummaryCardEl
                    cardWidth="100%"
                    setStatusFocused={setStatusFocused}
                    statusFocused={statusFocused}
                    setFilterList={setFilterList}
                    setInternFilterTypeList={setInternFilterTypeList}
                    status_id={102}
                    data={[...internType2, ...internType3]}
                    title="สหกิจศึกษา"
                    qtyColorText=""
                  />
                </div>
              </div>
            </div>
          </div>

          <div>

          
          </div>

          <div style={{ display: "flex", overflowX: "scroll" }}>
            {internStudentList.filter((el) => el.status_id == 31).length > 0 && (
              <div style={{ minWidth: "250px", margin: "0 1px" }}>
                <SummaryCardEl
                  cardWidth="100%"
                  setStatusFocused={setStatusFocused}
                  statusFocused={statusFocused}
                  setFilterList={setFilterList}
                  setInternFilterTypeList={setInternFilterTypeList}
                  status_id={31}
                  data={internStudentList.filter((el) => el.status_id == 31)}
                  title="สถานประกอบการรับเข้าฝึกงาน"
                  qtyColorText="#00FF15"
                  percentage={
                    internStudentActive.filter((el) => Number(el.status_id) !== 0).length -
                    internStudentActive.filter((el) => el.status_id == 15).length -
                    internStudentActive.filter((el) => el.status_id == 32).length -
                    internStudentActive.filter((el) => el.status_id == 14).length -
                    internStudentActive.filter((el) => el.status_id == 13).length > 0
                      ? Math.round(
                          (internStudentList.filter((el) => el.status_id == 31).length /
                            (internStudentActive.filter((el) => Number(el.status_id) !== 0).length -
                              internStudentActive.filter((el) => el.status_id == 15).length -
                              internStudentActive.filter((el) => el.status_id == 32).length -
                              internStudentActive.filter((el) => el.status_id == 14).length -
                              internStudentActive.filter((el) => el.status_id == 13).length)) *
                            100
                        )
                      : 0
                  }
                />
              </div>
            )}

            {internStudentList.filter(
              (el) =>
                el.status_id == 0 ||
                el.status_id == 14 ||
                el.status_id == 15 ||
                el.status_id == 32
            ).length > 0 && (
              <div style={{ minWidth: "250px", margin: "0 1px" }}>
                <SummaryCardEl
                  cardWidth="100%"
                  setStatusFocused={setStatusFocused}
                  statusFocused={statusFocused}
                  setFilterList={setFilterList}
                  setInternFilterTypeList={setInternFilterTypeList}
                  status_id={100}
                  data={internStudentList.filter(
                    (el) =>
                      el.status_id == 0 ||
                      el.status_id == 14 ||
                      el.status_id == 15 ||
                      el.status_id == 32
                  )}
                  title="ยังไม่ได้ยื่นคำขอฝึกงาน"
                  qtyColorText="#e01b22"
                />
              </div>
            )}

            {internStudentList.filter((el) => el.status_id == 3).length > 0 && (
              <div style={{ minWidth: "250px", margin: "0 1px" }}>
                <SummaryCardEl
                  cardWidth="100%"
                  setStatusFocused={setStatusFocused}
                  statusFocused={statusFocused}
                  setFilterList={setFilterList}
                  setInternFilterTypeList={setInternFilterTypeList}
                  status_id={3}
                  data={internStudentList.filter((el) => el.status_id == 3)}
                  title="ส่งหนังสือออก / รอบริษัทตอบรับ"
                  qtyColorText="#1876D1"
                />
              </div>
            )}

            {internStudentList.filter((el) => el.status_id == 1).length > 0 && (
              <div style={{ minWidth: "250px", margin: "0 1px" }}>
                <SummaryCardEl
                  cardWidth="100%"
                  setStatusFocused={setStatusFocused}
                  statusFocused={statusFocused}
                  setFilterList={setFilterList}
                  setInternFilterTypeList={setInternFilterTypeList}
                  status_id={1}
                  data={internStudentList.filter((el) => el.status_id == 1)}
                  title="ยื่นคำขอฝึกงานแล้ว"
                  qtyColorText="blue"
                />
              </div>
            )}

            {internStudentList.filter((el) => el.status_id == 12).length > 0 && (
              <div style={{ minWidth: "250px", margin: "0 1px" }}>
                <SummaryCardEl
                  cardWidth="100%"
                  setStatusFocused={setStatusFocused}
                  statusFocused={statusFocused}
                  setFilterList={setFilterList}
                  setInternFilterTypeList={setInternFilterTypeList}
                  status_id={12}
                  data={internStudentList.filter((el) => el.status_id == 12)}
                  title="อนุมัติคำร้อง"
                  qtyColorText="green"
                />
              </div>
            )}

            {internStudentList.filter((el) => el.status_id == 2).length > 0 && (
              <div style={{ minWidth: "250px", margin: "0 1px" }}>
                <SummaryCardEl
                  cardWidth="100%"
                  setStatusFocused={setStatusFocused}
                  statusFocused={statusFocused}
                  setFilterList={setFilterList}
                  setInternFilterTypeList={setInternFilterTypeList}
                  status_id={2}
                  data={internStudentList.filter((el) => el.status_id == 2)}
                  title="เตรียมออกหนังสือขอความอนุเคราะห์"
                  qtyColorText="orange"
                />
              </div>
            )}

            {internStudentList.filter((el) => el.status_id == 21).length > 0 && (
              <div style={{ minWidth: "250px", margin: "0 1px" }}>
                <SummaryCardEl
                  cardWidth="100%"
                  setStatusFocused={setStatusFocused}
                  statusFocused={statusFocused}
                  setFilterList={setFilterList}
                  setInternFilterTypeList={setInternFilterTypeList}
                  status_id={21}
                  data={internStudentList.filter((el) => el.status_id == 21)}
                  title="ออกหนังสือขอความอนุเคราะห์แล้ว"
                  qtyColorText="#F1D507"
                />
              </div>
            )}

            {internStudentList.filter((el) => el.status_id == 11).length > 0 && (
              <div style={{ minWidth: "250px", margin: "0 1px" }}>
                <SummaryCardEl
                  cardWidth="100%"
                  setStatusFocused={setStatusFocused}
                  statusFocused={statusFocused}
                  setFilterList={setFilterList}
                  setInternFilterTypeList={setInternFilterTypeList}
                  status_id={11}
                  data={internStudentList.filter((el) => el.status_id == 11)}
                  title="ตรวจสอบสถานประกอบการใหม่"
                  qtyColorText="#F7F759"
                />
              </div>
            )}
          </div>

          <div className="card flex-fill">
            <div className="row">
              <div className="col-lg-12">{displayTable}</div>
            </div>
          </div>
        </div>
        {displayProfile}
      </main>
    </div>
  );

  const renderProgressByBranch = (stList = [], b_id) => {
    const filterList = stList.filter((st) => st.b_id == b_id);
    const activeCount = filterList.filter((el) => Number(el.status_id) !== 0).length;
    const totalCount = filterList.length;
    const percentage = totalCount > 0 ? Math.round((activeCount / totalCount) * 100) : 0;

    return (
      <div className="card shadow-sm border-0">
        <div className="card-body p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="mb-0 fw-bold text-primary">
              {matchOptions(optionsBranch, b_id)}
            </h6>
            <div className="d-flex align-items-center">
              <span className="badge bg-light text-dark me-2">
                {activeCount} / {totalCount}
              </span>
              <span className="badge bg-success">
                {percentage}%
              </span>
            </div>
          </div>

          <div className="progress" style={{ height: '8px', borderRadius: '4px' }}>
            <ProgressBarEl
              stList={filterList}
              bgColor="#F7F759"
              statusId={11}
            />
            <ProgressBarEl
              stList={filterList}
              bgColor="blue"
              statusId={1}
              statusIdPrev={11}
            />
            <ProgressBarEl
              stList={filterList}
              bgColor="green"
              statusId={12}
              statusIdPrev={1}
            />
            <ProgressBarEl
              stList={filterList}
              bgColor="orange"
              statusId={2}
              statusIdPrev={12}
            />
            <ProgressBarEl
              stList={filterList}
              bgColor="#F1D507"
              statusId={21}
              statusIdPrev={2}
            />
            <ProgressBarEl
              stList={filterList}
              bgColor="#1876D1"
              statusId={3}
              statusIdPrev={21}
            />
            <ProgressBarEl
              stList={filterList}
              bgColor="#00FF15"
              statusId={31}
              statusIdPrev={3}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderInterntypeByBranch = (
    stList1 = [],
    b_id,
    stType1 = [],
    stType2 = [],
    stType3 = []
  ) => {
    const filterList1 = stList1.filter((st) => st.b_id == b_id);
    const ListType1 = stType1.filter((st) => st.b_id == b_id);
    const ListType2 = stType2.filter((st) => st.b_id == b_id);
    const ListType3 = stType3.filter((st) => st.b_id == b_id);

    return (
      <div className="card-body p-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div>{matchOptions(optionsBranch, b_id)}</div>
          <div className="ms-3">
            {ListType1.length === 0 
              ? ListType2.length + ListType3.length
              : ListType2.length + ListType3.length === 0 
                ? ListType1.length
                : `${ListType1.length} / ${ListType2.length + ListType3.length}`
            }
          </div>
        </div>
        <div className="progress">
          <div
            className="progress-bar"
            role="progressbar"
            aria-label="type-1"
            
            style={{
              width: `${Math.round(
                (ListType1.length /
                  (filterList1.filter((el) => Number(el.status_id) !== 0).length -
                    filterList1.filter((el) => el.status_id == 15).length -
                    filterList1.filter((el) => el.status_id == 32).length -
                    filterList1.filter((el) => el.status_id == 14).length)) *
                  100
              )}%`,
            }}

            
            aria-valuenow={Math.round(
              (ListType1.length /
                (filterList.filter((el) => Number(el.status_id) !== 0).length -
                  filterList1.filter((el) => el.status_id == 15).length -
                  filterList1.filter((el) => el.status_id == 32).length -
                  filterList1.filter((el) => el.status_id == 14).length)) *
                100
            )}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            { ListType1.length > 0 && `${Math.round(
              (ListType1.length /
                (filterList1.filter((el) => Number(el.status_id) !== 0).length -
                  filterList1.filter((el) => el.status_id == 15).length -
                  filterList1.filter((el) => el.status_id == 32).length -
                  filterList1.filter((el) => el.status_id == 14).length)) *
                100
            )}% `}
          </div>

          <div
            className="progress-bar bg-success"
            role="progressbar"
            aria-label="type-2-3"
            style={{
              width: `${Math.round(
                ([...ListType2, ...ListType3].length /
                  (filterList1.filter((el) => Number(el.status_id) !== 0).length -
                    filterList1.filter((el) => Number(el.status_id) === 15).length -
                    filterList1.filter((el) => Number(el.status_id) === 32).length -
                    filterList1.filter((el) => Number(el.status_id) === 14).length)) *
                  100
              )}%`,
            }}
            aria-valuenow={Math.round(
              (ListType1.length /
                (filterList1.filter((el) => Number(el.status_id) !== 0).length -
                  filterList1.filter((el) => Number(el.status_id) === 15).length -
                  filterList1.filter((el) => Number(el.status_id) === 32).length -
                  filterList1.filter((el) => Number(el.status_id) === 14).length)) *
                100
            )}
            aria-valuemin={Math.round(
              ([...ListType2, ...ListType3].length /
                (filterList1.filter((el) => Number(el.status_id) !== 0).length -
                  filterList1.filter((el) => el.status_id == 15).length -
                  filterList1.filter((el) => el.status_id == 32).length -
                  filterList1.filter((el) => el.status_id == 14).length)) *
                100
            )}
            aria-valuemax={100}
            aria-valuetext={"a"}
          >
            {" "}
            { (ListType2.length >0 || ListType3.length >0) &&  `${Math.round(
              ([...ListType2, ...ListType3].length /
                (filterList1.filter((el) => Number(el.status_id) !== 0).length -
                  filterList1.filter((el) => el.status_id == 15).length -
                  filterList1.filter((el) => el.status_id == 32).length -
                  filterList1.filter((el) => el.status_id == 14).length)) *
                100
            )}% `}{" "}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div>
        {displayDashboard}
        <ModalCrudCompany2
          setIsOpen={setIsOpenModal}
          modalIsOpen={isOpenModal}
        />
        <ModalView
          isModaOpen={modalChartOpen}
          setIsModalOpen={setModalChartOpen}
          title={
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <h4 className="mb-0 text-primary fw-bold">
                  <i className="fas fa-chart-line me-2"></i>
                  สถานะการยื่นขอฝึกงานของนิสิต ปีการศึกษา {selectedYear}
                </h4>
              </div>
              <small className="text-muted">
                <i className="fas fa-clock me-1 ms-3"></i>
                อัปเดต: {dayjs().format("DD/MM/YYYY HH:mm")}
              </small>
            </div>
          }
        >
          <Box maxWidth={1200} minWidth={800}>
            <div className="row g-3">
              <div className="col-md-6">
                {renderProgressByBranch(internStudentList2, "1")}
              </div>
              <div className="col-md-6">
                {renderProgressByBranch(internStudentList2, "2")}
              </div>
              <div className="col-md-6">
                {renderProgressByBranch(internStudentList2, "3")}
              </div>
              <div className="col-md-6">
                {renderProgressByBranch(internStudentList2, "4")}
              </div>
              <div className="col-md-6">
                {renderProgressByBranch(internStudentList2, "5")}
              </div>
              <div className="col-md-6">
                {renderProgressByBranch(internStudentList2, "6")}
              </div>
              <div className="col-md-6">
                {renderProgressByBranch(internStudentList2, "7")}
              </div>
              <div className="col-md-6">
                {renderProgressByBranch(internStudentList2, "8")}
              </div>
            </div>
          </Box>
        </ModalView>
      </div>
      <div>
        <ModalCrudCompany2
          setIsOpen={setIsOpenModal2}
          modalIsOpen={isOpenModal2}
        />
        <ModalView
          isModaOpen={modalChartOpen2}
          setIsModalOpen={setModalChartOpen2}
          title={
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <h4 className="mb-0 text-primary fw-bold me-3">
                  <i className="fas fa-chart-pie me-2"></i>
                  รูปแบบการฝึกงานและสหกิจศึกษา ปีการศึกษา {selectedYear}
                </h4>
                <div>
                  <span className="badge bg-primary me-2">ฝึกงาน 2 เดือน</span>
                  <span className="badge bg-success">สหกิจศึกษา</span>
                </div>
              </div>
              <small className="text-muted">
                <i className="fas fa-clock me-1 ms-3"></i>
                อัปเดต: {dayjs().format("DD/MM/YYYY HH:mm")}
              </small>
            </div>
          }
        >
          <Box maxWidth={1200} minWidth={800}>
            <div className="row g-3">
              <div className="col-md-6">
                {renderInterntypeByBranch(
                  internStudentList3,
                  "1",
                  internType1a,
                  internType2a,
                  internType3a
                )}
              </div>
              <div className="col-md-6">
                {renderInterntypeByBranch(
                  internStudentList3,
                  "2",
                  internType1a,
                  internType2a,
                  internType3a
                )}
              </div>
              <div className="col-md-6">
                {renderInterntypeByBranch(
                  internStudentList3,
                  "3",
                  internType1a,
                  internType2a,
                  internType3a
                )}
              </div>
              <div className="col-md-6">
                {renderInterntypeByBranch(
                  internStudentList3,
                  "4",
                  internType1a,
                  internType2a,
                  internType3a
                )}
              </div>
              <div className="col-md-6">
                {renderInterntypeByBranch(
                  internStudentList3,
                  "5",
                  internType1a,
                  internType2a,
                  internType3a
                )}
              </div>
              <div className="col-md-6">
                {renderInterntypeByBranch(
                  internStudentList3,
                  "6",
                  internType1a,
                  internType2a,
                  internType3a
                )}
              </div>
              <div className="col-md-6">
                {renderInterntypeByBranch(
                  internStudentList3,
                  "7",
                  internType1a,
                  internType2a,
                  internType3a
                )}
              </div>
              <div className="col-md-6">
                {renderInterntypeByBranch(
                  internStudentList3,
                  "8",
                  internType1a,
                  internType2a,
                  internType3a
                )}
              </div>
            </div>
          </Box>
        </ModalView>
      </div>
    </>
  );
};

export default Dashboard;
